import { Button } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { useFinancialWorkspace } from 'modules/finance/components/FinancialWorkspace/Providers/Provider'
import { usePanelData } from 'modules/finance/components/FinancialWorkspace/components/ResponsivePageWithPanel/dataProvider'
import { usePanel } from 'modules/finance/components/FinancialWorkspace/components/ResponsivePageWithPanel/provider'
import {
  PERIODS_LABELS,
  getDatePeriod,
} from 'modules/finance/components/FinancialWorkspace/lib/datePeriod'

import { PanelData } from '..'

export const CurrentPeriodButton = () => {
  const { formattedState } = useFinancialWorkspace()
  const { setOpen } = usePanel()
  const { setData } = usePanelData<PanelData>()

  const label = useUnsafeCallback(() => {
    const startDate = moment(formattedState.formattedStartDate)
    const endDate = moment(formattedState.formattedEndDate)

    const period = getDatePeriod(startDate, endDate)

    switch (period) {
      case PERIODS_LABELS.monthly:
        return startDate.format('MMMM YYYY')
      case PERIODS_LABELS.yearly:
        return startDate.format('YYYY')
      default:
        return startDate.format('MMMM YYYY') + ' - ' + endDate.format('MMMM YYYY')
    }
  }, [formattedState.formattedStartDate, formattedState.formattedEndDate])

  const handleClick = useUnsafeCallback(() => {
    setData({
      startDate: formattedState.formattedStartDate,
      endDate: formattedState.formattedEndDate,
      label: label(),
    })
  }, [formattedState.formattedStartDate, formattedState.formattedEndDate, label, setData])

  useUnsafeEffect(() => {
    handleClick()
  }, [formattedState.formattedStartDate, formattedState.formattedEndDate, handleClick])

  return (
    <Button
      type="secondary"
      iconName="clock"
      onClick={() => {
        setOpen(true)
        handleClick()
      }}
    />
  )
}
